import React from "react";
import { Adviser } from "../../../../../../Wrap/Models/Domains/Adviser/Adviser";
import { CompanySummary } from "../../../../../../Wrap/Models/Models/Company/CompanySummary";
import { Alert } from "../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../Shared/Entities/Constants/AlertConstants";
import { IAddClientModel } from "../../../Clients/AddClient/Components/AddClientWizard";
import { Filter } from "../../../Clients/AddClient/Components/ClientType/Filter";

interface IWorkflowDashboardSearchProps {
    onSearch: (selectedFirm: CompanySummary, selectedAdviser?: number) => void;
}

const WorkflowDashboardSearch = (props: IWorkflowDashboardSearchProps) => {
    const filterRef = React.useRef<any>();
    const [filterState, setFilterState] = React.useState<{
        adviser: number;
        firm: CompanySummary;
        networkName: string;
    }>({
        adviser: null,
        firm: null,
        networkName: null,
    });
    const [showWarningMsg, setShowWarningMsg] = React.useState(false);

    return (
        <>
            {showWarningMsg && <Alert alertType={AlertType.Warning} message={"Please select a firm or adviser"} />}
            <Filter
                data={null}
                onRef={(ref) => {
                    filterRef.current = ref;
                }}
                onFilterSelectionChange={onChangeFilterSelection}
                onOneDefaultCompany={(company) => props.onSearch(company, null)}
                onChange={() => {}}
                adviserOptional={true}
            />

            <button className="btn secondary" onClick={onClickSearch}>
                Search
            </button>
        </>
    );

    function isValid() {
        if (filterState.firm) {
            return true;
        }
        setShowWarningMsg(true);
        return false;
    }

    function onClickSearch() {
        if (isValid() && filterRef.current?.isValid()) {
            props.onSearch(filterState.firm, filterState.adviser);
        }
    }

    function onChangeFilterSelection(value: IAddClientModel) {
        setShowWarningMsg(false);
        if (value.SelectedFirm) {
            setFilterState({
                adviser: value?.SelectedAdviser?.AdvisorId,
                firm: value?.SelectedFirm,
                networkName: value?.SelectedNetwork?.NetworkName,
            });
        } else if (value?.Organisation?.OwnerAdviserId) {
            const filter = filterState;
            filter.adviser = value?.Organisation?.OwnerAdviserId;
            setFilterState(filter);
        }
    }
};

export default WorkflowDashboardSearch;
